import { render, staticRenderFns } from "./OrderMenuConfirmation.vue?vue&type=template&id=4b67e47a&scoped=true"
import script from "./OrderMenuConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderMenuConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OrderMenuConfirmation.vue?vue&type=style&index=0&id=4b67e47a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b67e47a",
  null
  
)

export default component.exports